import type { TFunction } from 'i18next';
import type {
  CompletedStep,
  EditEventType,
  States,
} from '~/subscription-management/checkout/state-machine/checkout.machine.types';
import type { Step } from '../../shared/header/HeaderStep';

export interface CheckoutStep extends Step<Extract<States, string>> {
  event?: EditEventType;
}

export const getCheckoutSteps = (
  tHeader: TFunction,
  completedSteps: CompletedStep[],
): CheckoutStep[] => {
  return [
    {
      id: 'editOrder.steps.editSubscription',
      event: 'SETUP_SUBSCRIPTION',
      text: tHeader('manage-subscriptions'),
      previouslyCompleted: completedSteps.includes('editOrder.steps.editSubscription'),
    },
    {
      id: 'editOrder.steps.invoiceDetails',
      event: 'INVOICE_DETAILS',
      text: tHeader('invoice-details'),
      previouslyCompleted: completedSteps.includes('editOrder.steps.invoiceDetails'),
    },
    {
      id: 'editOrder.steps.paymentDetails',
      event: 'PAYMENT_DETAILS',
      text: tHeader('payment-details'),
      previouslyCompleted: completedSteps.includes('editOrder.steps.paymentDetails'),
    },
    {
      id: 'editOrder.steps.reviewOrder',
      event: 'REVIEW_ORDER',
      text: tHeader('review-order'),
    },
  ];
};
